import React from 'react';

import { CircleSlashIcon, PulseIcon } from '@primer/octicons-react';

import { IconBadge } from '../../common/Badge/Badge';

export const PipelineStatusBadge = ({ status, textColor = 'text-white' }) => (
  <IconBadge
    bgColor={status === 'Active' ? 'bg-green-500' : 'bg-gray-500'}
    icon={status === 'Active' ? PulseIcon : CircleSlashIcon}
    textColor={textColor}
  >
    {status}
  </IconBadge>
)

export default PipelineStatusBadge;
